/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedSourcesRouteImport } from './routes/_authed/sources'
import { Route as AuthedSkillsRouteImport } from './routes/_authed/skills'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin/users'
import { Route as AuthedAdminAuditRouteImport } from './routes/_authed/admin/audit'

const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSourcesRoute = AuthedSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSkillsRoute = AuthedSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAuditRoute = AuthedAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthedAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/skills': typeof AuthedSkillsRoute
  '/sources': typeof AuthedSourcesRoute
  '/admin/audit': typeof AuthedAdminAuditRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/admin/': typeof AuthedAdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/skills': typeof AuthedSkillsRoute
  '/sources': typeof AuthedSourcesRoute
  '/admin/audit': typeof AuthedAdminAuditRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/admin': typeof AuthedAdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/skills': typeof AuthedSkillsRoute
  '/_authed/sources': typeof AuthedSourcesRoute
  '/_authed/admin/audit': typeof AuthedAdminAuditRoute
  '/_authed/admin/users': typeof AuthedAdminUsersRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sso-callback'
    | '/admin'
    | '/dashboard'
    | '/skills'
    | '/sources'
    | '/admin/audit'
    | '/admin/users'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sso-callback'
    | '/dashboard'
    | '/skills'
    | '/sources'
    | '/admin/audit'
    | '/admin/users'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/sso-callback'
    | '/_authed/admin'
    | '/_authed/dashboard'
    | '/_authed/skills'
    | '/_authed/sources'
    | '/_authed/admin/audit'
    | '/_authed/admin/users'
    | '/_authed/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  SsoCallbackRoute: typeof SsoCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/sources': {
      id: '/_authed/sources'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof AuthedSourcesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/skills': {
      id: '/_authed/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthedSkillsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/users': {
      id: '/_authed/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthedAdminUsersRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/audit': {
      id: '/_authed/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AuthedAdminAuditRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminAuditRoute: typeof AuthedAdminAuditRoute
  AuthedAdminUsersRoute: typeof AuthedAdminUsersRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminAuditRoute: AuthedAdminAuditRoute,
  AuthedAdminUsersRoute: AuthedAdminUsersRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedSkillsRoute: typeof AuthedSkillsRoute
  AuthedSourcesRoute: typeof AuthedSourcesRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedSkillsRoute: AuthedSkillsRoute,
  AuthedSourcesRoute: AuthedSourcesRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  SsoCallbackRoute: SsoCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
